module.exports = __webpack_public_path__ + "static/media/line-vert-full.68a60d0d.svg";